import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
    DRIPSET_LOGO,
    HOSPITAL_APPROVED_IMAGE_SRC,
    NURSE_APPROVED_IMAGE_SRC,
} from '@constants/images';
import {
    DEVICE_LIST_PATH,
    LOGIN_PATH,
    DASHBOARD_PATH,
    ONBOARDING_PATH,
    ANALYTICS_PATH,
} from '@constants/routes';
import { HOSPITAL, NURSE } from '@constants/constants';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import { userStatusUpdate } from '@utils/login';
import { USER_INFO_TABLE } from '@constants/dynamoDBTableName';
import { FaArrowLeftLong } from 'react-icons/fa6';

const ApprovedPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userRole = useAppSelector((state) => state.login.loggedInUserRole);
    const loggedInUserInfoUuid = useAppSelector(
        (state) => state.login.loggedInUserInfoUuid
    );
    const loggedInUserTenantID = useAppSelector(
        (state) => state.login.loggedInUserTenantID
    );

    const handleBackClick = () => {
        navigate(LOGIN_PATH);
    };
    const handleGetStartedClick = async () => {
        try {
            await userStatusUpdate(
                USER_INFO_TABLE,
                loggedInUserInfoUuid,
                loggedInUserTenantID
            );
            if (userRole.toLowerCase() == HOSPITAL.toLowerCase()) {
                navigate(ANALYTICS_PATH);
            } else if (userRole.toLowerCase() == NURSE.toLowerCase()) {
                navigate(DEVICE_LIST_PATH);
            } else {
                navigate(ONBOARDING_PATH);
            }
        } catch (error: any) {
            // console.log('Failed to update item:', error);
        }
    };

    return (
        <div className="bg-white w-full min-h-screen over">
            <div className="flex items-center justify-between px-4 py-3">
                <div
                    className="flex items-center cursor-pointer absolute top-0 mt-4 text-lg text-nero font-semibold"
                    onClick={handleBackClick}
                >
                    <FaArrowLeftLong className="mr-2 cursor-pointer" />
                    <span>{t('auth.back')}</span>
                </div>
                <div className="flex-grow flex justify-center">
                    <div className="logo-container">
                        <Link to={LOGIN_PATH}>
                            <img
                                src={DRIPSET_LOGO}
                                alt="Dripset_logo"
                                className="object-contain"
                            />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="flex flex-col items-center justify-center mt-2">
                <div className="mx-auto flex justify-center my-3">
                    {userRole.toLowerCase() == HOSPITAL.toLowerCase() && (
                        <img
                            src={HOSPITAL_APPROVED_IMAGE_SRC}
                            alt="OTP"
                            className=" object-contain"
                        />
                    )}
                    {userRole.toLowerCase() == NURSE.toLowerCase() && (
                        <img
                            src={NURSE_APPROVED_IMAGE_SRC}
                            alt="OTP"
                            className=" object-contain"
                        />
                    )}
                </div>
                <div className="text-center">
                    <h3 className="text-2xl font-semibold text-black mb-2">
                        {t('auth.approval.title')}
                    </h3>
                    <p className="text-grey test-sm font-normal mb-3">
                        {t('auth.approval.description')}
                        <br />
                        {t('auth.approval.description_1')}
                        <br />
                        {userRole.toLowerCase() == HOSPITAL.toLowerCase() && (
                            <>
                                {t('auth.approval.description_2')}
                                <br />
                            </>
                        )}
                        {userRole.toLowerCase() == NURSE.toLowerCase() && (
                            <>
                                {t('auth.approval.description_nurse')}
                                <br />
                            </>
                        )}
                    </p>
                    <button
                        type="submit"
                        className="btn w-4/5 mt-2 py-3 px-4 !bg-primary !hover:bg-primary text-white font-semibold rounded-lg"
                        onClick={handleGetStartedClick}
                    >
                        {t('auth.approval.get_started')}
                    </button>
                </div>
            </div>
        </div>
    );
};
export default ApprovedPage;
